import {memo} from 'react';

export const OnTrackSVG = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16">
    <path
      stroke="#1A9E68"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.335 4L9 10.333 5.668 7l-5 5"
    />
    <path
      stroke="#1A9E68"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.332 4h4v4"
    />
  </svg>
));

OnTrackSVG.displayName = 'OnTrackSVG';
